import { createClient } from '@/shared/api';
import type {
  UpdateStudySecondaryContactMutation,
  UpdateStudySecondaryContactMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_SECONDARY_CONTACT from '../mutations/updateStudySecondaryContact';

/**
 * Saves the patient's secondary contact details on a study. Runs UPDATE_STUDY_SECONDARY_CONTACT and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudySecondaryContact payload.
 */
const handleUpdateStudySecondaryContact = async (
  input: UpdateStudySecondaryContactMutationVariables['input'],
): Promise<UpdateStudySecondaryContactMutation['updateStudySecondaryContact']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudySecondaryContactMutation,
    UpdateStudySecondaryContactMutationVariables
  >({
    mutation: UPDATE_STUDY_SECONDARY_CONTACT,
    variables: { input },
  });
  const { data } = result;
  const { updateStudySecondaryContact } = data ?? {};
  if (!updateStudySecondaryContact?.isSuccess) {
    throw new Error(updateStudySecondaryContact?.message ?? undefined);
  }
  return updateStudySecondaryContact;
};

export default handleUpdateStudySecondaryContact;
